<div class="container-broker-code-registration-modal">
    <div *ngIf="typeModal === 'error'">
        <h2>Ops! Algo deu errado</h2>
        <h3>Dá uma olhadinha nesses itens:</h3>
        <div class="container-list-broker-code-registration-modal">
            <ul>
                <li *ngFor="let i of listErrors">{{ i }}</li>
            </ul>
        </div>
        <div class="footer-broker-code-registration-modal">
            <button class="btn btn-primary" (click)="closeModal()">Fechar</button>
        </div>
    </div>
    <div *ngIf="typeModal === 'info'">
        <button class="btn button-close-info" (click)="closeModal()">
            <i class="material-icons" style="font-size: 20px; cursor: pointer;" title="Fechar">close</i>
        </button>
        <div class="container-info">
            <p>Toda importação nova que for realizada, irá excluir os dados da importação anterior.</p>
            <p>Caso necessário validação de dados importados anteriormente, abaixo encontrará a listagem das importações realizadas.</p>
        </div>
    </div>
</div>
